import { useDispatch, useSelector } from "react-redux"
import logo from '../../assets/images/logo.svg'
import mp3Logo from '../../assets/images/mp3.png'
import { popupModelDataActions } from "../../store/popupModelData"

export const PopUpDialog = ({ modalType }) => {
    const modelData = useSelector(state => state.popupModelData.data)
    const clickedAttachmentIndex = useSelector(state => state.popupModelData.dataIndex)
    const dispatch = useDispatch()
    const resetModal = () => {
        let players = document.getElementsByClassName('Player')
        // let carousels = document.getElementsByClassName("carousel-item active")
        // for (let i = 0; i < carousels.length; i++) {
        //     if(i != clickedAttachmentIndex) {
        //         carousels[i].classList.remove("active")
        //     }
        // }
        for (let i = 0; i < players.length; i++) {
            players[i].pause()
            players[i].currentTime = 0
        }
        setTimeout(() => {
            dispatch(popupModelDataActions.setData([]))
        }, 100)
    }

    return (
        <>
            <div className="modal fade text-left" id={modalType} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel1">Ideas</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={resetModal}>
                            <i className="fas fa-times"></i>
                            </button>
                        </div>
                        <div
                            className="modal-body"
                            style={{ overflowY: "auto", maxHeight: "calc(100vh - 150px)" }}>
                            <div id="carouselControls" className="carousel slide carousel-fade" data-interval="false" data-ride="carousel">
                                <div className="carousel-inner">

                                    {modelData.map((attachment, index) => {

                                        let attachmentTag
                                        if (attachment.ATTACHMENT_TYPE == '.mp4') {
                                            attachmentTag = <video className="d-block w-100 h-500p Player" src={`${attachment.ATTACHMENT}`} controls></video>
                                        }
                                        else if (attachment.ATTACHMENT_TYPE == ".mp3") {
                                            attachmentTag = <div className="w-100 h-500p"><img src={mp3Logo} className="aud-img" alt="img" /><audio className="aud-player" src={`${attachment.ATTACHMENT}`} controls></audio></div>
                                        }
                                        else if (attachment.ATTACHMENT_TYPE == ".pdf") {
                                            attachmentTag = <iframe className="d-block w-100 h-500p" src={attachment.ATTACHMENT} type="application/pdf"></iframe>
                                        }
                                        else {
                                            attachmentTag = <img className="d-block w-100 h-500p" src={attachment.ATTACHMENT}></img>
                                        }

                                        const isActive = index == clickedAttachmentIndex ? "active" : ""
                                        return (
                                            <div className={`carousel-item ` + isActive} key={index}>
                                                {attachmentTag}
                                            </div>
                                        )
                                    })}
                                </div>
                                <a className="carousel-control-prev" href="#carouselControls" role="button" data-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="false"></span>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className="carousel-control-next" href="#carouselControls" role="button" data-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}